import { render, staticRenderFns } from "./my-team.vue?vue&type=template&id=10fb826a&scoped=true&"
import script from "./my-team.vue?vue&type=script&lang=js&"
export * from "./my-team.vue?vue&type=script&lang=js&"
import style0 from "./my-team.vue?vue&type=style&index=0&id=10fb826a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb826a",
  null
  
)

export default component.exports